import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import splitHtmlString from '../utilities/splitHtmlString.js';

gsap.registerPlugin(ScrollTrigger);

export default function Hero() {
  return {
    init: () => {
      const hero = document.querySelector('.w-b-hero');
      if (!hero) return;

      const images = hero.querySelectorAll('.w-b-hero__image');
      if (images.length > 1) {
        let currentImage = 0;
        setInterval(() => {
          images[currentImage].classList.remove('w-is-current');

          currentImage++;
          if (currentImage === images.length) {
            currentImage = 0;
          }

          images[currentImage].classList.add('w-is-current');
        }, 6000);
      }

      const title = hero.querySelector('.w-b-hero__title');
      title.innerHTML = splitHtmlString(title.innerHTML, true);

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: hero,
          start: 'top 10%',
          // invalidateOnRefresh: true,
        },
      });

      const outerSpans = title.querySelectorAll('& > span');
      const innerSpans = title.querySelectorAll('& > span > span');
      gsap.set(innerSpans, {
        display: 'inline-block',
        position: 'relative',
      });

      timeline.fromTo(
        outerSpans,
        {
          opacity: 0,
          clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
          // translateX: '1rem', // only works if not inline, but inline-block breaks kerning
        },
        {
          opacity: 1,
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          // translateX: 0,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.out',
        },
        0.25
      );
      timeline.fromTo(
        innerSpans,
        {
          translateY: '100%',
        },
        {
          translateY: 0,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.out',
        },
        0.25
      );

      timeline.fromTo(
        [
          document.querySelector('.w-header__logo'),
          hero.querySelector('.w-b-hero__button'),
          hero.querySelector('.w-b-hero__scroll-to'),
          document.querySelector('.w-menu--header'),
        ],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1.5,
          ease: 'power2.inOut',
        },
        0.5
      );
    },
  };
}
